import {Box, IconButton, Typography} from '@mui/material';
import './ProcessingSyncHeader.scss';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';

export const TEST_IDS = {
  CONTAINER: 'processing-sync-header',
  TITLE: 'processing-sync-title',
  TOOLTIP_BUTTON: 'tooltip-button',
  INFO_ICON: 'info-icon',
} as const;

const ProcessingSyncHeader = () => {
  return (
    <Box className="processing-sync-header" data-testid={TEST_IDS.CONTAINER}>
      <Box className="title-row">
        <Typography
          className="typo-text headline3_size title-label"
          data-testid={TEST_IDS.TITLE}
        >
          {t('ingestions.mapped.processingsync.processingSync')}
        </Typography>

        <ArrTooltipWrapper
          title={t('ingestions.mapped.processingsync.tooltipTitle')}
          trigger={
            <IconButton
              aria-label="Info"
              className="info-icon-button"
              data-testid={TEST_IDS.TOOLTIP_BUTTON}
            >
              <InfoOutlinedIcon
                className="info-icon"
                fontSize="medium"
                data-testid={TEST_IDS.INFO_ICON}
              />
            </IconButton>
          }
        >
          <Typography
            className="preline-text"
            data-testid="processing-sync-header-typography"
          >
            <Trans
              i18nKey="ingestions.mapped.processingsync.tooltip"
              components={{
                bold: <strong data-testid="processing-sync-header-strong" />,
              }}
            />
          </Typography>
        </ArrTooltipWrapper>
      </Box>
    </Box>
  );
};

export default ProcessingSyncHeader;
